import { styled } from 'linaria/react';
import { css } from 'linaria';

export const StyledLink = styled.a`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.12px;
	text-decoration: none;
	color: var(--text-primary);
	border-bottom: 1px solid var(--text-primary);
`;

export const Manual = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	column-gap: 6px;
	margin-block: 40px;
`;

export const ManualLinkStyles = css`
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0.05px;
`;
